import { Avatar, IAvatarProps, Size } from '@busybusy/webapp-react-ui';
import { AddIcon, EditIcon } from 'assets/icons';
import classNames from 'classnames';
import CircularIconButton from 'components/foundation/buttons/CircularIconButton/CircularIconButton';
import Spinner from 'components/foundation/Spinner/Spinner';
import * as React from 'react';
import './ImageDrawer.scss';

export interface IImageDrawerProps {
  images: IImagePayload[];
  size: Size | 'xl';
  numInitials?: 1 | 2;
  loading?: boolean;
  error?: boolean;
  onButtonClick?: (event: React.MouseEvent) => void;
  className?: string | object;
}

export type IImagePayload = Omit<IAvatarProps, 'size' | 'numInitials'>;

const ImageDrawer = (props: IImageDrawerProps) => {
  const { images, size, numInitials, onButtonClick, loading, error, className } = props;

  function renderEditButton() {
    if (onButtonClick) {
      if (images.length > 0) {
        return <CircularIconButton svg={EditIcon} size={size} onClick={onButtonClick} />;
      } else {
        return <CircularIconButton svg={AddIcon} size={size} onClick={onButtonClick} />;
      }
    } else {
      return null;
    }
  }

  function renderImages() {
    return images.map((image) => {
      return (
        <Avatar key={image.firstName + image.lastName + image.image} {...image} size={size} numInitials={numInitials} />
      );
    });
  }

  const classes = classNames(
    {
      'image-drawer': true,
      'error': error,
    },
    className
  );

  return (
    <div className={classes}>
      {renderEditButton()}
      {loading ? <Spinner /> : <>{renderImages()}</>}
    </div>
  );
};

ImageDrawer.defaultProps = {
  ...Avatar.defaultProps,
};

export default ImageDrawer;
